import { render, staticRenderFns } from "./forgetPhone.vue?vue&type=template&id=55d4dcac&scoped=true"
import script from "./forgetPhone.vue?vue&type=script&lang=js"
export * from "./forgetPhone.vue?vue&type=script&lang=js"
import style0 from "./forgetPhone.vue?vue&type=style&index=0&id=55d4dcac&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d4dcac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55d4dcac')) {
      api.createRecord('55d4dcac', component.options)
    } else {
      api.reload('55d4dcac', component.options)
    }
    module.hot.accept("./forgetPhone.vue?vue&type=template&id=55d4dcac&scoped=true", function () {
      api.rerender('55d4dcac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms/smsConfig/components/forgetPhone.vue"
export default component.exports